import { Observable } from 'rxjs';

export interface FileRaderReturn {
	text: string;
	binary: ArrayBuffer;
}

export type FileReaderOptions = keyof FileRaderReturn;

export function readFile<T extends FileReaderOptions>(files: File, type: T): Observable<FileRaderReturn[T]> {
	return readFiles<T>([files], type);
}

export function readFiles<T extends FileReaderOptions>(files: File[], type: T): Observable<FileRaderReturn[T]> {
	return new Observable<FileRaderReturn[T]>((subscriber) => {
		const reader = new FileReader();

		const next = () => {
			switch (type) {
				case 'text':
					reader.readAsText(files.shift());
					break;
				case 'binary':
					reader.readAsArrayBuffer(files.shift());
					break;
			}
		};

		const loadHandler = (e: Event) => {
			subscriber.next((e.target as FileReader).result as FileRaderReturn[T]);

			if (files.length > 0) {
				next();
			} else {
				subscriber.complete();
			}
		};
		const errorHandler = (e: Event) => {
			subscriber.error((e.target as FileReader).error);
		};
		reader.addEventListener('load', loadHandler);
		reader.addEventListener('error', errorHandler);

		next();

		return () => {
			reader.removeEventListener('load', loadHandler);
			reader.removeEventListener('error', errorHandler);
		};
	});
}
